export default function Logo({ className = "", light = true, size = "md" }) {
  const stroke = light ? "#D4AF37" : "#0D1038";
  const text = light ? "text-ivory" : "text-navy";
  const dims = size === "lg" ? { w: 52, h: 26, t: "1.05rem", s: "0.62rem" } : { w: 40, h: 20, t: "0.9rem", s: "0.55rem" };

  return (
    <span className={`inline-flex items-center gap-3 ${className}`} aria-label="End to End Destinations">
      <svg width={dims.w} height={dims.h} viewBox="0 0 64 32" fill="none" aria-hidden>
        <path
          d="M32 16 C 26 6, 10 6, 10 16 C 10 26, 26 26, 32 16 C 38 6, 54 6, 54 16 C 54 26, 38 26, 32 16 Z"
          stroke={stroke} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
      <span className="flex flex-col leading-none">
        <span className={`font-serif ${text}`} style={{ fontSize: dims.t, letterSpacing: "0.14em", lineHeight: 1 }}>
          END<span className="text-gold"> TO </span>END
        </span>
        <span className="text-gold" style={{ fontFamily: "'Manrope', sans-serif", fontSize: dims.s, letterSpacing: "0.42em", marginTop: "0.28em", fontWeight: 500 }}>
          DESTINATIONS
        </span>
      </span>
    </span>
  );
}
